import React, { useState, useEffect } from 'react'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { Helmet } from 'react-helmet-async'
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { HiOutlineBuildingLibrary } from "react-icons/hi2";

function BDA_job() {
  const canonicalUrl =
    'https://www.internselite.net/Business-Development-Associate'
  useEffect(() => {
    document.title = 'Business Development Executive | InternsElite'
  }, [])

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    collegeName: '',
  })

  const [nameError, setNameError] = useState(' ')
  const [emailError, setEmailError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [collegeError, setCollegeError] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`)
      } else {
        setNameError('')
      }
    }

    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError('Invalid email format')
      } else {
        setEmailError('')
      }
    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError('Length Should be 10 Digit')
      } else {
        setPhoneError('')
      }
    }
    if (name === 'collegeName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setCollegeError(`Invalid College Name format.`)
      } else {
        setCollegeError('')
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    $.ajax({
      url: 'https://forms.internselite.net/BDAform',
      type: 'POST',
      data: {
        fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        collegeName: $('[name="collegeName"]').val(),
      },
      success: function (response) {
        Swal.fire({
          title: 'Form Submitted!',
          text:
            'Thank you for applying to be a Business Development Executive! Your application has been received, You will get the Interview call soon. For Resume mail Us to support@internselite.com',
          icon: 'success',
        })
        $('[name="collegeName"]').val('')
        $('[name="fullName"]').val('')
        $('[name="mobileNo"]').val('')
        $('[name="email"]').val('')
      },
      error: function (error) {
        console.error('Error:', error)
      },
    })
  }

  return (
    <div>
      <Helmet>
        <title>
          Business Development Associate Program | InternsElite - Bridge to
          Industry Excellence
        </title>
        <meta
          name="description"
          content="Step into the role of a Business Development Associate at InternsElite and unlock the door to unparalleled professional growth. Our program equips you with strategic marketing skills, corporate networking opportunities, and leadership development, paving your way to become an industry leader. Join us to transform your potential into success."
        />
        <meta
          name="keywords"
          content="Business Development Associate, Corporate Networking Opportunities, InternsElite BDA, Strategic Marketing Skills, Professional Growth, Leadership Development"
        />
        <meta
          property="og:title"
          content="Business Development Associate Program | InternsElite - Bridge to Industry Excellence"
        />
        <meta
          property="og:description"
          content="Step into the role of a Business Development Associate at InternsElite and unlock the door to unparalleled professional growth. Our program equips you with strategic marketing skills, corporate networking opportunities, and leadership development, paving your way to become an industry leader. Join us to transform your potential into success."
        />
        <meta
          property="og:url"
          content="https://internselite.net/Business-Development-Associate"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="Business Development Associate Program | InternsElite - Bridge to Industry Excellence"
        />
        <meta
          name="twitter:description"
          content="Step into the role of a Business Development Associate at InternsElite and unlock the door to unparalleled professional growth. Our program equips you with strategic marketing skills, corporate networking opportunities, and leadership development, paving your way to become an industry leader. Join us to transform your potential into success."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      {/* -----------------------------Mobile View------------------------- */}
      <div className="BDA_background_element d-sm-block d-md-none mt-5 pt-4">
        <div className="container pb-5 pt-4">
          <div className="mobile_BDA_text">
            <h1 className="display-6 text-center pt-4">
              InternsElite- Business Development Executive Profile
            </h1>
            <p className="text-center">
              Experience professional transformation with the InstersElite
              Business Development Executive Program. This expansive offering
              gives you insider knowledge, cutting-edge skills, and industry
              connections. Our comprehensive professional development programme
              for aspiring company executives promotes strategic thinking,
              excellent communication, and market knowledge.{' '}
            </p>
            <span>Job Description:-</span>
            <ul className="">
              <li className="pt-3">
                Explore students' aspirations for their future careers,
                answering their questions and easing their fears so you can help
                them succeed.
              </li>
              <li className="pt-2">
                Learn how students' individual experiences impact their job
                choices by delving into their educational and personal
                backgrounds.
              </li>
              <li className="pt-2">
                Create individualised career plans that play to their interests
                and play to their skills.
              </li>
              <li className="pt-2">
                Give students all the information they need about the courses
                they're interested in, making sure they know how they will help
                them achieve their career goals.
              </li>
              <li className="pt-2">
                Help students make well-informed selections by pointing out
                options and excellent career paths.
              </li>
              <li className="pt-2">
                Effortlessly record consultations to make learning easier for
                students.
              </li>
              <li className="pt-2">
                Successfully ending the consultation and leaving students with
                relevant information is crucial for ensuring a good outcome.
              </li>
              <li className="pt-2">
                Help students better comprehend the processes involved in
                pursuing their chosen professions by directing them toward the
                appropriate educational programs.
              </li>
            </ul>
            <span className="">Qualifications:</span>
            <p className="pt-2 pb-3">
              B.Tech (all specialisation),MBA(all specialisation),BBA(all
              specialisation),BCA,MCA, B.com.
            </p>
          </div>
          <div className="pb-2">
            <div className="BDA_form_text shadow-lg px-3 py-4">
              <div className="text-center border-bottom pb-2">
                <span>Apply Now...</span>
              </div>
              <div className="">
                <form onSubmit={handleSubmit}>
                  <div class="mt-3">
                    <label for="fullName" class="pb-2 px-2 contact_form">
                      <SlUser size="20px" color="#565add" /> Full Name
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="fullName"
                      name="fullName"
                      placeholder="Your answer"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      required
                    />
                    {nameError && (
                      <div className="error text-danger">{nameError}</div>
                    )}
                  </div>
                  <div class="mt-3">
                    <label for="email" class="pb-2 px-2 contact_form">
                      <MdOutlineMailOutline size="20px" color="#565add" /> Email
                      Address
                    </label>
                    <input
                      className="form-control"
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Your answer"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                    {emailError && (
                      <div className="error text-danger">{emailError}</div>
                    )}
                  </div>
                  <div class="mt-3">
                    <label for="mobileNo" class="pb-2 px-2 contact_form">
                      <HiOutlinePhone size="20px" color="#565add" /> Phone
                      Number
                    </label>
                    <input
                      className="form-control"
                      type="tel"
                      id="mobileNo"
                      name="mobileNo"
                      placeholder="+91 xxxxxxxxxx"
                      value={formData.mobileNo}
                      onChange={handleInputChange}
                      required
                    />
                    {phoneError && (
                      <div className="error text-danger">{phoneError}</div>
                    )}
                  </div>
                  <div class="my-3">
                    <label for="collegeName" class="pb-2 px-2 contact_form ">
                      <HiOutlineBuildingLibrary size="20px" color="#565add" /> College
                      Name
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="collegeName"
                      name="collegeName"
                      placeholder="Your answer"
                      value={formData.collegeName}
                      onChange={handleInputChange}
                      required
                    />
                    {collegeError && (
                      <div className="error text-danger">{collegeError}</div>
                    )}
                  </div>
                  <div className="row mt-2 pt-4">
                    <div className="d-flex justify-content-center">
                      <button className="shadow-sm mx-4 px-5 pt-2 pb-2 Contact_button">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------------Desktop View--------------------------------- */}
      <div className="BDA_background_element d-none d-md-block  my-5">
        <div className="container pt-5 mt-5">
          <div className="row mt-3">
            <div className="col-md-7 px-2 pt-3">
              <div className="BDA_text pt-4">
                <h1 className="display-6">
                  InternsElite- Business Development Executive Profile
                </h1>
                <p className="pt-2">
                  Experience professional transformation with the InstersElite
                  Business Development Executive Program. This expansive
                  offering gives you insider knowledge, cutting-edge skills, and
                  industry connections. Our comprehensive professional
                  development programme for aspiring company executives promotes
                  strategic thinking, excellent communication, and market
                  knowledge.
                </p>
                <span>Job Description:-</span>
                <ul className="pb-3">
                  <li className="pt-4">
                    Explore students' aspirations for their future careers,
                    answering their questions and easing their fears so you can
                    help them succeed.
                  </li>
                  <li className="pt-2">
                    Learn how students' individual experiences impact their job
                    choices by delving into their educational and personal
                    backgrounds.
                  </li>
                  <li className="pt-2">
                    Create individualised career plans that play to their
                    interests and play to their skills.
                  </li>
                  <li className="pt-2">
                    Give students all the information they need about the
                    courses they're interested in, making sure they know how
                    they will help them achieve their career goals.
                  </li>
                  <li className="pt-2">
                    Help students make well-informed selections by pointing out
                    options and excellent career paths.
                  </li>
                  <li className="pt-2">
                    Effortlessly record consultations to make learning easier
                    for students.
                  </li>
                  <li className="pt-2">
                    Successfully ending the consultation and leaving students
                    with relevant information is crucial for ensuring a good
                    outcome.
                  </li>
                  <li className="pt-2">
                    Help students better comprehend the processes involved in
                    pursuing their chosen professions by directing them toward
                    the appropriate educational programs.
                  </li>
                </ul>
                <span className="">Qualifications:</span>
                <p className="pt-2">
                  B.Tech (all specialisation),MBA(all specialisation),BBA(all
                  specialisation),BCA,MCA, B.com.
                </p>
              </div>
            </div>
            <div className="col-md-5">
              <div className="mt-5 px-5 py-4 BDA_form_text shadow-lg ">
                <span className="">Apply Now...</span>
                <div className="">
                  <form onSubmit={handleSubmit}>
                    <div class="mt-4">
                      <label for="fullName" class="pb-2 px-2 contact_form">
                        <SlUser size="20px" color="#565add" /> Full Name
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        id="fullName"
                        name="fullName"
                        placeholder="Your answer"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        required
                      />
                      {nameError && (
                        <div className="error text-danger">{nameError}</div>
                      )}
                    </div>
                    <div class="mt-3">
                      <label for="email" class="pb-2 px-2 contact_form">
                        <MdOutlineMailOutline size="20px" color="#565add" />{' '}
                        Email Address
                      </label>
                      <input
                        className="form-control"
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Your answer"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                      {emailError && (
                        <div className="error text-danger">{emailError}</div>
                      )}
                    </div>
                    <div class="mt-3">
                      <label for="mobileNo" class="pb-2 px-2 contact_form">
                        <HiOutlinePhone size="20px" color="#565add" /> Phone
                        Number
                      </label>
                      <input
                        className="form-control"
                        type="tel"
                        id="mobileNo"
                        name="mobileNo"
                        placeholder="+91 xxxxxxxxxx"
                        value={formData.mobileNo}
                        onChange={handleInputChange}
                        required
                      />
                      {phoneError && (
                        <div className="error text-danger">{phoneError}</div>
                      )}
                    </div>
                    <div class="my-3">
                      <label for="collegeName" class="pb-2 px-2 contact_form ">
                        <HiOutlineBuildingLibrary size="20px" color="#565add" /> College
                        Name
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        id="collegeName"
                        name="collegeName"
                        placeholder="Your answer"
                        value={formData.collegeName}
                        onChange={handleInputChange}
                        required
                      />
                      {collegeError && (
                        <div className="error text-danger">{collegeError}</div>
                      )}
                    </div>
                    <div className="row mt-2 pt-4">
                      <div className="d-flex justify-content-center">
                        <button className="shadow-sm mx-4 px-5 pt-2 pb-2 Contact_button">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BDA_job
